import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  RoutesRecognized,
  UrlTree,
} from '@angular/router';
import { filter, Observable, pairwise } from 'rxjs';
import { FirestoreService } from 'src/app/shared/services/firestore.service';

@Injectable({
  providedIn: 'root',
})
export class AdminguardGuard implements CanActivateChild {
  constructor(
    private firestoreService: FirestoreService,
    private router: Router
  ) {}

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let url: string = state.url;
    return this.checkUserRole(next, url, state);
  }

  async checkUserRole(
    route: ActivatedRouteSnapshot,
    url: any,
    state: any
  ):
  Promise<boolean> {
    return new Promise(async (resolve) => {
      const res: any = await this.firestoreService.getAuthUserProfile();
      console.log(res);
      
      if (res && res.role) {
        if (res.role === 'admin') {
          resolve(true); 
        } else {
          // 🚦 Redirect based on role
          if (res.role === 'customer') {
            this.router.navigateByUrl('/customer');
          }  else if (res.role === 'servicemanager') {
            this.router.navigateByUrl('/servicemanager');
          } else if (res.role === 'productmanager') {
            this.router.navigateByUrl('/productmanager');
          } else if (res.role === 'business') {
            this.router.navigateByUrl('/business');
          }
          resolve(false);
        }
      } else {
        this.router.navigateByUrl('/');
        resolve(false);
      }
      console.log('dasda');
      
    });
  }
}
